import { useEffect, useState } from 'react';
import { checkPendingSangrias } from '../services/Financas/sangriaOperation';

const EVENT = 'finance:updated';
const STORAGE_KEY = 'osteomed:finance-updated';

export function notifyFinancialUpdate(clinica) {
  const detail = { clinica, timestamp: Date.now(), nonce: Math.random() };
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(detail)); } catch { /* Same-tab event still works. */ }
}

export default function useFinancialRefresh() {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const refresh = () => setRevision((value) => value + 1);
    const onStorage = (event) => { if (event.key === STORAGE_KEY) refresh(); };
    const checkPending = () => checkPendingSangrias(notifyFinancialUpdate);
    const timer = setInterval(checkPending, 15000);
    checkPending();
    window.addEventListener('focus', checkPending);
    window.addEventListener(EVENT, refresh);
    window.addEventListener('storage', onStorage);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', checkPending);
      window.removeEventListener(EVENT, refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return revision;
}
